import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46a88fe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { useRoute, useRouter } from 'vue-router';
import { onMounted, reactive, computed, inject } from 'vue'
import ViewContext from '@/views/ViewContext';
import chajing from '@/api/chajingApi'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const context = inject('context') as ViewContext
const route = useRoute()
const temp = reactive({
    content: '',
    font: 18,
    color: '',
})
const fontSize = computed(() => {
    return {
        fontSize: temp.font + 'px',
        color: temp.color
    }
})
onMounted(() => {
    loadData()
    window.addEventListener('message', function (e) {
        if (e.data.key == 'setFontSize') {
            temp.font = e.data.value
        } else if (e.data.key == 'setColor') {
            temp.color = e.data.value
        } else {
            console.info('unknow message', e.data)
        }
    })
    window.parent.postMessage('ready', '*')
})

async function loadData() {
    let volume = parseInt(route.params.volume as string)
    let chapter = parseInt(route.params.chapter as string)
    let sid = parseInt(route.params.sid as string)
    let r = await chajing.getBookDetail(volume, chapter, sid)
    temp.content = r.content.replace(/<audio src="(.+?)".+?><\/audio>/g, '<div class="audioDom"><div src="$1" id="audioDom"></div></div>')
        .replace(/<a .+?>(.+?)<\/a>/g, '$1')
    setTimeout(checkAudio, 50);
}
function checkAudio() {
    let dom = document.getElementById('audioDom')
    if (dom) {
        let url = dom.getAttribute('src')
        if (url) {
            const poster = '/video.gif'
            context.createAliPlayer('audioDom', url, function () { }, {
                auto: false, poster, isLive: false, rate: true, isAudio: true
            })
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "page",
    style: _normalizeStyle(_unref(fontSize))
  }, [
    _createElementVNode("div", {
      class: "book-html",
      innerHTML: _unref(temp).content
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})